import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Wandavision from './pages/Wandavision'
import IndvText from './pages/IndvText'
import Search from './pages/Search';
import About from './pages/About';
import Scoring from './pages/Scoring';
import WaltDisneyCompany from './pages/WaltDisneyCompany';
import AAPI from './pages/AAPI';
import ComingSoon from './pages/ComingSoon';
import NotFound from './pages/NotFound';

import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// import Courses from './pages/Courses';
import './App.scss';
import { Analytics } from '@vercel/analytics/react';


const App = () => {

   // scroll to top stuff https://v5.reactrouter.com/web/guides/scroll-restoration
   const { pathname } = useLocation();

   useEffect(() => {
     window.scrollTo(0, 0);
   }, [pathname]);

  return (
     <>
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/wandavision" element={<Wandavision />} />
            <Route path="/search" element={<Search />} />
            <Route path="/about" element={<About />} />
            <Route path="/scoring" element={<Scoring />} />
            <Route path="/comingsoon" element={<ComingSoon />} />
            <Route path="/waltdisneycompany" element={<WaltDisneyCompany />} />
            <Route path="/aapi" element={<AAPI />} />

            <Route path="/reviews/:title" element={<IndvText />} />

            <Route path="*" element={<NotFound />} status={404}/>
            <Route path="/reviews/*" element={<NotFound />} status={404}/>
        </Routes>
        <Analytics />
     </>
  );
 };
 

export default App;
